export const contact = {
  contactType: '',
  label: '',
  value: '',
  error: '',
  isActive: true,
  isPrimary: false,
  isMarketingNotifEnabled: true,
  isOperationalNotifEnabled: true,
};

export const phoneTypes = Object.freeze([
  { label: 'Mobile', value: 'mobile' },
  { label: 'Landline', value: 'landline' },
]);

export const calculationTypes = Object.freeze([
  { label: 'Percentage', value: 'percentage' },
  { label: 'Fixed', value: 'value' },
]);

export const newCustomer = {
  firstName: '',
  lastName: '',
  fullNameQBO: '',
  isActive: true,
  chargeAccountEnable: false,
  email: '',
  phone: '',
  notes: '',
  taxExempt: false,
  taxExemptReason: {
    qboId: '',
  },
  taxExemptReasonId: '',
  contactOnEmail: false,
  contactOnPhone: false,
  address: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    stateCode: '',
  },
  businessAddress: {
    addLine1: '',
    addLine2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    stateCode: '',
  },
  emails: [
    {
      ...contact,
      isPrimary: true,
      contactType: { label: 'Email', value: 'email' },
    },
  ],
  phones: [
    {
      ...contact,
      isPrimary: true,
      contactType: { label: 'Mobile', value: 'mobile' },
    },
  ],
  tags: [],
};
